import { ToolbarProps, Typography, useTheme } from '@mui/material'
import { BasePage, BasePageProps, CoverProgress, FlexCol, FlexGrowCol } from '@xylabs/sdk-react'
import { XyoNetworkWrapper } from '@xyo-network/sdk-xyoworld-js'
import { ReactElement, useContext } from 'react'

import PortalAppBar from '../AppBar'
import { Footer } from '../Components'
import { AuthenticationContext } from '../Contexts'

interface Props extends BasePageProps {
  paused?: boolean
  requireAdmin?: boolean
  requireAuth?: boolean
  toolbar?: ReactElement<ToolbarProps>
}

const WorldBasePage: React.FC<Props> = (props) => {
  const networks = new Map<number, XyoNetworkWrapper>()
  const localhost = new XyoNetworkWrapper(5777)
  const theme = useTheme()

  networks.set(5777, localhost)

  const { children, requireAdmin, toolbar, paused = true, ...rootProps } = props
  const { authEntity } = useContext(AuthenticationContext)

  const requireAuth = props.requireAuth || requireAdmin

  if (requireAuth && authEntity === undefined) {
    return (
      <FlexGrowCol>
        <CoverProgress />
      </FlexGrowCol>
    )
  }

  if (requireAdmin && authEntity?.admin !== true) {
    return <FlexGrowCol>{JSON.stringify(authEntity)}</FlexGrowCol>
  }

  return (
    <BasePage appBar={<PortalAppBar>{toolbar}</PortalAppBar>} appFooter={<Footer />} {...rootProps}>
      {paused ? (
        <FlexCol bgcolor={theme.palette.error.main} color={theme.palette.error.contrastText} paddingX={2}>
          <Typography align="center">Auctions are paused in preparation for XYO World 4.0 - Coming Q4-2023</Typography>
        </FlexCol>
      ) : null}
      {children}
    </BasePage>
  )
}

export default WorldBasePage
